import { HTMLInputProps, INumericInputProps, NumericInput } from '@blueprintjs/core'
import React from 'react'

export interface NullSafeNumericInputProps extends INumericInputProps {
  //   Blueprint <NumericInput /> 2.32 (and above) rounds the initial value to the nearest minorStepSize step
  //     e.g.
  //     for minorStepSize 1:
  //     1.99 would round to 2
  //
  //     for minorStepSize 0.01:
  //     1.99 would stay as to 1.99

  minorStepSize: number
  preventNegative?: boolean
}

// NullSafeNumericInput
// - handles missing `value` prop gracefully
// - requires minorStepSize to prevent unexpected rounding
// - also prevents negative values if preventNegative is true
const NullSafeNumericInput: React.FC<NullSafeNumericInputProps & HTMLInputProps> = props => {
  const nullSafeValue = [null, undefined].includes(props.value) ? '' : props.value
  const nullSafeProps = { ...props, value: nullSafeValue }
  return (
    <NumericInput
      {...nullSafeProps}
      onInput={e => {
        if (props.preventNegative && !e.currentTarget.value.includes('e')) {
          e.currentTarget.value = e.currentTarget.value.replace(/[^0-9.]/g, '')
        }
        if (props.onInput) {
          props.onInput(e)
        }
      }}
    />
  )
}

export default NullSafeNumericInput
